/**
 * Custom Javascript Code for PROfertil theme geoip Detection. Plugin Geoip detect must be installed: https://github.com/yellowtree/geoip-detect
 *
 * @author Eberhard Lauth
 *
 */

( function ( $ ) {

    $(document).ready(function() {

        /*geoip_detect.get_info().then(function(record) {
            if (record.error()) {
                console.error('WARNING Geodata Error:' + record.error() );
            }
            var country_class = 'country-' + record.get('country.iso_code', 'unknown');
            $('body').addClass(country_class);

            /!* Code for Russia*!/
            if (country_class === 'country-RU') {
                var translationUrl = 'https://translate.google.com/translate?sl=auto&tl=ru&u=' + $(location).attr('href');
                $('body').append('<div class="reveal" id="translate-modal-ru" data-reveal data-animation-in="fade-in" data-animation-out="fade-out" data-close-on-click="false">' +
                    '<p>You can use a translation program like Google Translate to translate this page to your local language.</p>' +
                    '<div class="grid-x"><div class="cell small-6"><a class="button cancel-button" data-close>No, thanks!</a></div>' +
                    '<div class="cell small-6 continue"><a class="button" href="' + translationUrl + '">Translate now</a></div>' +
                    '</div>');
                $('#translate-modal-ru').foundation();
                /!* Open modal once, then set cookie*!/
                if (Cookies.get('translate_modal_ru_shown') == null) {
                    Cookies.set('translate_modal_ru_shown', 'yes', {
                        expires: 1,
                        path: '/'
                    });
                    setTimeout(function (event) {
                        $('#translate-modal-ru').foundation('open');
                    }, 1000);
                }
            }
        });*/
    });

} )( jQuery );